import { render, staticRenderFns } from "./OmDashboard.vue?vue&type=template&id=0aba2496&"
import script from "./OmDashboard.vue?vue&type=script&lang=js&"
export * from "./OmDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports